import type { ReactNode } from "react";

/** Direct React port of Agenda's AppTableList shell. */
export function AppTableList({ filters, headerInfo, children, footer, className = "" }: {
  filters?: ReactNode;
  headerInfo?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}) {
  return (
    <section className={`app-table-list-container ${className}`.trim()}>
      {(filters || headerInfo) && <div className="filters-header">
        {filters && <div className="filters-content">{filters}</div>}
        {headerInfo && <div className="header-info">{headerInfo}</div>}
      </div>}
      <div className="list-wrapper"><div className="list-content">{children}</div>{footer}</div>
    </section>
  );
}
